import { List, ListItem, ListItemText } from "@mui/material";

import UserBadge from "~/modules/user/components/UserBadge";

import { FieldworkerAssignmentListStatusIcon } from "./FieldworkerAssignmentListStatusIcon";
import { FieldworkerAssignmentsStatusMessage } from "./FieldworkerAssignmentStatusMessage";
import { FieldworkerAssignmentsFragment } from "./fragments.generated";

type FieldworkerAssignmentListProps = {
    fieldworkers: FieldworkerAssignmentsFragment[];
    fieldworkersRequired: number;
    fieldworkersStillNeeded: number;
};

export function FieldworkerAssignmentList({
    fieldworkers,
    fieldworkersRequired,
    fieldworkersStillNeeded,
}: FieldworkerAssignmentListProps) {
    return (
        <List sx={{ padding: 0 }}>
            {fieldworkers.map(fieldworker => (
                <ListItem
                    key={fieldworker.id}
                    sx={theme => ({
                        borderTop: `1px solid ${theme.palette.divider}`,
                        columnGap: 1,
                    })}
                >
                    <UserBadge
                        size={24}
                        key={fieldworker.id}
                        names={[fieldworker.user.firstName, fieldworker.user.lastName]}
                        profilePicture={fieldworker.user.profilePictureMedia?.url}
                    />
                    <ListItemText>
                        {fieldworker.user.firstName} {fieldworker.user.lastName}
                    </ListItemText>
                </ListItem>
            ))}
            <ListItem
                sx={theme => ({
                    columnGap: 1,
                    borderTop: `1px solid ${theme.palette.divider}`,
                    alignItems: "center",
                })}
            >
                <FieldworkerAssignmentListStatusIcon fieldworkersStillNeeded={fieldworkersStillNeeded} />
                <ListItemText sx={theme => ({ color: theme.palette.text.secondary })}>
                    <FieldworkerAssignmentsStatusMessage
                        fieldworkersRequired={fieldworkersRequired}
                        fieldworkersAssigned={fieldworkers.length}
                        fieldworkersStillNeeded={fieldworkersStillNeeded}
                    />
                </ListItemText>
            </ListItem>
        </List>
    );
}
